import angular from 'angular';
import blogSliderComponent from './blog-slider.component';
import blogSliderConfig from './blog-slider.config';

let blogSliderModule = angular.module('app.blogSlider',[])
  .component('blogSlider', blogSliderComponent)
  .config(blogSliderConfig);

export default blogSliderModule;



// WEBPACK FOOTER //
// ./www/components/blog/blog-slider/blog-slider.js